import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { PageHeader } from "../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../shared/components/pageHeader/PageHeaderApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { QueryErrorBoundary } from "../../../core/api/components/QueryErrorBoundary"
import { Suspense } from "react"
import { LoadingSpinner } from "../../../shared/components/loading/LoadingSpinner"
import { UserProfileContent } from "../components/UserProfileContent"

export function UserProfile() {
    return (
        <>
            <LocalizedStrict id="profile-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.USER_ACCOUNT}
                    title="User account"
                    icon={<FontAwesomeIcon icon={faInfoCircle} />}
                />
            </LocalizedStrict>
            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <UserProfileContent />
                </Suspense>
            </QueryErrorBoundary>
        </>
    )
}
